export interface AppConfig {
	API_URL?: string;
	WS_URL?: string;
	EDITOR_BASE_URL?: string;
	GOOGLE_CLIENT_ID?: string;
	REDIRECT_URI_CALENDAR?: string;
}

declare global {
	interface Window {
		__APP_CONFIG__?: AppConfig;
	}
}

const appConfig: AppConfig = window.__APP_CONFIG__ || {};

export const API_URL = appConfig.API_URL || process.env.VUE_APP_API_URL || "";
export const WS_URL =
	appConfig.WS_URL || process.env.VUE_APP_WEBSOCKET_URL || "";
export const EDITOR_BASE_URL =
	appConfig.EDITOR_BASE_URL || process.env.VUE_APP_EDITOR_BASE_URL || "";
export const GOOGLE_CLIENT_ID =
	appConfig.GOOGLE_CLIENT_ID || process.env.VUE_APP_GOOGLE_CLIENT_ID || "";
export const REDIRECT_URI_CALENDAR =
	appConfig.REDIRECT_URI_CALENDAR ||
	process.env.VUE_APP_REDIRECT_URI_CALENDAR ||
	"";

export default appConfig;
